import { Pipe, PipeTransform } from '@angular/core';
import { MatterPackageWithStatusAndDocuments } from '../documents-v2.selectors';
import { matterPackageTypeKeys } from '@models/matter-package';

@Pipe({
	name: 'packageIcon',
	standalone: true,
})
export class PackageIconPipe implements PipeTransform {
	transform(
		pkg: MatterPackageWithStatusAndDocuments,
		isExpanded: boolean,
	): string {
		const hasDocuments = pkg.documents.length > 0;
		const hasSyncMortgageId = !!pkg.syncMortgageId;
		const isEnvelope =
			pkg.packageTypes?.[matterPackageTypeKeys.IsSigningPackage];

		if (isEnvelope) {
			// Envelopes use a fixed icon (no open/closed variants)
			return '/assets/icons/matter-packages/package-envelope.svg';
		} else if (hasSyncMortgageId) {
			// Sync packages use a fixed icon (no open/closed variants)
			return '/assets/icons/matter-packages/package-sync.svg';
		} else if (hasDocuments) {
			// Regular packages with documents
			return `/assets/icons/matter-packages/package-icon${isExpanded ? '-open' : ''}.svg`;
		} else {
			// Empty packages
			return `/assets/icons/matter-packages/package-icon-empty${isExpanded ? '-open' : ''}.svg`;
		}
	}
}
